<div class="w-full members-container" *ngIf="members">
    <header class="w-full flex  border-b-2">
        <div class="flex h-8 justify-center font-extrabold flex-[1]"><span *ngIf="hasOrder">{{ 'DASHBOARDHISTORY.ORDER' |translate }}</span></div>
        <div class="flex h-8 justify-center font-extrabold w-32 flex-grow">{{ 'DASHBOARDHISTORY.MEMBERS' | translate }}</div>
        <div class="flex h-8 justify-center font-extrabold flex-[2]">{{ 'DASHBOARDHISTORY.CATEGORY' |translate }}</div>
        <div class="flex h-8 justify-center font-extrabold flex-[2]">{{ 'DASHBOARDHISTORY.CONTROL' | translate }}</div>
        <div class="flex h-8 justify-center font-extrabold flex-[2]">{{ 'DASHBOARDHISTORY.DATE_HOUR' | translate }}</div>
        <div *ngIf="!readonly" class="flex-[3] flex h-8 justify-center font-extrabold">{{ 'ACTIONS' | translate }}</div>
    </header>
    <div class="w-full max-h-[40vh] overflow-y-auto">

    <ng-container *ngFor="let member of members; let i = index">
        <div class="w-full flex  min-h-12" *ngIf="member.type !== 'GROUP'; else groupMemberTemplate">
            <div class="border-r-2 border-dashed flex items-center justify-center flex-[1]">
                <strong *ngIf="hasOrder && !member.hasApproDocument"> {{ member.order || 0 }}. </strong>
            </div>
            <!-- USER MEMBER -->
            <div class="border-r-2 border-dashed py-1 pl-3 flex  w-32 flex-grow items-center gap-2 whitespace-nowrap text-ellipsis overflow-hidden">
                <img src="assets/svg/awe-user-circle.svg" class="w-[20px] h-[20px]" />
                <!-- <mat-icon class="scale-100" svgIcon="user-circle"></mat-icon> --> {{ member.name }} <mat-icon *ngIf="member.hasPreemptiveRight" [matTooltip]="'PROJECT.MEMBERS.TABLE.PREEMPTIVE_RIGHT_LONG' | translate">supervised_user_circle</mat-icon>
            </div>
            <!-- CATEGORIES -->
            <div class="border-r-2 border-dashed justify-center flex  items-center flex-[2]">
                <span class="italic font-thin" *ngIf="member.hasApproDocument">{{ 'MAIN_APPROVER' | translate }}</span>
                <span class="italic font-thin" *ngIf="member.hasApproInfo && !member.hasApproDocument">{{ 'INFO_APPROVER' | translate }}</span>
                <span class="italic font-thin" *ngIf="!member.hasApproInfo && !member.hasApproDocument">{{ 'OBSERVER_APPROVER' | translate }}</span>
            </div>
            <!-- CONTROLE -->
            <div class="border-r-2 border-dashed justify-center flex flex-col items-center flex-[2]">
                <div class="flex items-center gap-2">
                    <ng-container *ngIf="member.hasApproInfo || member.hasApproDocument; else readonlyStatus">
                        <span [className]="'rounded-full w-3 h-3 bg-' + member?.status || ''"></span>
                        <span class="font-extrabold italic">{{ ('MEMBERS_STATUS.' + member?.status) | uppercase | translate}}</span>
                    </ng-container>
                    <ng-template #readonlyStatus>
                        <span>-</span>
                    </ng-template>
                </div>
                <div class="text-gray-500 italic flex gap-1 text-xs" *ngIf="member.decision_makerID && member.decision_maker">
                    <span>{{ 'DECISION_TAKEN_BY' | translate }}</span>
                    <span>{{ member.decision_maker.fullname }}</span>
                </div>
            </div>
            <!-- DATE -->
            <div class="justify-center flex  items-center font-extralight italic flex-[2]" [ngClass]="{ 'border-r-2 border-dashed': !readonly }"> {{ (member.status_date | date: 'dd/MM/yyyy HH:mm' ) || '-'}} </div>
            <!-- ACTION -->
            <div class="flex-[3] justify-center" *ngIf="!readonly">
                <div *ngIf="member.hasCurrentOrder(current_order) && can_approve && member.status === MEMBER_STATUS.PROGRESS && can_approve_on_behalf(member)" class="p-1 flex gap-2 justify-around">
                    <button class="px-3 py-1 bg-rejected" mat-flat-button (click)="onReject(member)">
                        <mat-icon>close</mat-icon>{{'APPROVE.REJECT' | translate}} </button>
                    <button class="px-3 py-1 bg-approved" mat-flat-button (click)="onApprove(member)">
                        <mat-icon>check</mat-icon>{{'APPROVE.VALID' | translate}} </button>
                </div>
            </div>
        </div>
        <ng-template #groupMemberTemplate>
            <!-- <div class="w-full flex flex-col bg-tw-lightgrey"> -->
            <!-- GROUP HEAD  -->
            <div class="w-full flex  min-h-12 bg-tw-lightgrey">
                <div class="border-r-2 border-dashed flex items-center justify-center flex-[1]">
                    <strong *ngIf="hasOrder && !member.hasApproDocument"> {{ member.order || 0 }}. </strong>
                </div>
                <div class="border-r-2 border-dashed flex py-1 pl-3 w-32 flex-grow items-center gap-2 whitespace-nowrap text-ellipsis overflow-hidden">
                    <mat-icon>group</mat-icon>
                    <strong class="italic">{{ member.name }}</strong>
                    <mat-icon *ngIf="member.hasPreemptiveRight" [matTooltip]="'PROJECT.MEMBERS.TABLE.PREEMPTIVE_RIGHT_LONG' | translate">supervised_user_circle</mat-icon>
                </div>
                <div class="border-r-2 border-dashed justify-center flex  items-center flex-[2]">
                    <span class="italic font-thin" *ngIf="member.hasApproDocument">{{ 'MAIN_APPROVER' | translate }}</span>
                    <span class="italic font-thin" *ngIf="member.hasApproInfo && !member.hasApproDocument">{{ 'INFO_APPROVER' | translate }}</span>
                    <span class="italic font-thin" *ngIf="!member.hasApproInfo && !member.hasApproDocument">{{ 'READ_ONLY_APPROVER' | translate }}</span>
                </div>
                <div class="border-r-2 border-dashed justify-center flex-[2] items-center flex flex-col">
                    <div class="flex items-center gap-2">
                        <ng-container *ngIf="member.hasApproInfo || member.hasApproDocument; else readonlyStatus">
                            <span [className]="'rounded-full w-3 h-3 bg-' + member?.status || ''"></span>
                            <span class="font-extrabold italic">{{ ('MEMBERS_STATUS.' + member?.status) | uppercase | translate}}</span>
                        </ng-container>
                        <ng-template #readonlyStatus>
                            <span>-</span>
                        </ng-template>
                    </div>
                    <div class="text-gray-500 italic flex gap-1 text-xs" *ngIf="member.decision_makerID && member.decision_maker">
                        <span>{{ 'DECISION_TAKEN_BY' | translate }}</span>
                        <span>{{ member.decision_maker.fullname }}</span>
                    </div>
                </div>
                <div class="border-r-2 border-dashed justify-center items-center flex font-extralight italic flex-[2]"> {{ (member.status_date | date: 'dd/MM/yyyy HH:mm' ) || '-'}} </div>
                <div class="flex-[3] justify-center" *ngIf="!readonly">
                    <div *ngIf="member.hasCurrentOrder(current_order) && can_approve && member.status === MEMBER_STATUS.PROGRESS && can_approve_on_behalf(member)" class="p-1 flex gap-2 justify-around">
                        <button class="px-3 py-1 bg-rejected" mat-flat-button (click)="onReject(member)">
                            <mat-icon>close</mat-icon>{{'APPROVE.REJECT' | translate}} </button>
                        <button class="px-3 py-1 bg-approved" mat-flat-button (click)="onApprove(member)">
                            <mat-icon>check</mat-icon>{{'APPROVE.VALID' | translate}} </button>
                    </div>
                </div>
            </div>
            <!-- GROUP MEMBER -->
            <div class="w-full flex min-h-12 bg-tw-lightgrey" *ngFor="let user of (member.users || [])">
                <div class="border-r-2 border-dashed flex items-center justify-center flex-[1]">
                </div>
                <div class="border-r-2 border-dashed p-1 !pl-8 flex w-32 flex-grow items-center gap-2 whitespace-nowrap text-ellipsis overflow-hidden">
                    <img src="assets/svg/awe-user-circle.svg" class="w-[20px] h-[20px]" />
                    <span class="italic">{{ user.fullname }}</span>
                </div>
                <div class="flex-[2] border-r-2 border-dashed flex justify-center items-center"><span class="italic">{{ 'GROUP_MEMBER' | translate }}</span></div>
                <div class="flex-[2] border-r-2 border-dashed justify-center flex items-center">
                    <div class="w-full flex items-center justify-center gap-2">
                        <span>-</span>
                    </div>
                </div>
                <div class="flex-[2] border-r-2 border-dashed justify-center font-extralight italic flex items-center">
                    <div class="w-full flex items-center justify-center gap-2">
                        <span>-</span>
                    </div>
                </div>
                <div class="flex-[3] justify-center" *ngIf="!readonly"></div>
            </div>
            <!-- </div> -->
        </ng-template>
    </ng-container>
</div>

</div>